import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Amplify } from 'aws-amplify';
import { awsConfig } from './services/auth/aws-exports';
import { installBackendAuth } from './services/auth/backendAuth';

// Polyfill URL.parse for libraries that rely on the proposed API.
if (typeof URL !== "undefined" && typeof URL.parse !== "function") {
  URL.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

// Configure Amplify
Amplify.configure(awsConfig);

// Send the login token on backend calls made outside apiConfig.
installBackendAuth();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
  //  <App />
  //</React.StrictMode>,
  <App />
);
